import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["inputField"]

  connect() {
    this.timeout = null;
    this.isSubmitting = false;

    this.boundStoreCache = this.storeCache.bind(this);
    this.inputFieldTarget.addEventListener("input", this.boundStoreCache);
  }

  disconnect() {
    if (this.inputFieldTarget) {
      this.inputFieldTarget.removeEventListener("input", this.boundStoreCache);
    }
    clearTimeout(this.timeout);
  }

  storeCache() {
    if (this.isSubmitting) return;

    clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.isSubmitting) return;

      const text = this.inputFieldTarget.value;
      const entryId = this.inputFieldTarget.dataset.id;
      const sentAt = Date.now() / 1000;

      try {
        await fetch(`/entries/${entryId}/store_data?text=${encodeURIComponent(text)}&sent_at=${sentAt}`, {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });
      } catch (error) {
        console.error("Ошибка автосохранения:", error);
      }
    }, 500);
  }

  clearTimer() {
    this.isSubmitting = true;
    clearTimeout(this.timeout);
  }

  clearCacheOnSuccess(event) {
    if (event.detail.formSubmission.result.success) {
      clearTimeout(this.timeout);

      if (this.inputFieldTarget) {
        this.inputFieldTarget.value = "";
        this.inputFieldTarget.dispatchEvent(new Event('change'));
      }
      this.isSubmitting = false;
    } else {
      this.isSubmitting = false;
    }
  }
}
